import { render, staticRenderFns } from "./PracticeFileUploadDetailPerson.vue?vue&type=template&id=747d9f4a&scoped=true&"
import script from "./PracticeFileUploadDetailPerson.vue?vue&type=script&lang=ts&"
export * from "./PracticeFileUploadDetailPerson.vue?vue&type=script&lang=ts&"
import style0 from "./PracticeFileUploadDetailPerson.vue?vue&type=style&index=0&id=747d9f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d9f4a",
  null
  
)

export default component.exports